import Package from "./package";
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import useNoInitialRenderEffect from "@/hooks/useNoInitialRenderEffect";
import AddButton from "@/components/add-button";
import { getShippingCost } from "./form-container";
import { useDebouncedEffect } from "@/hooks/useDebouncedEffect";
import { getParcelChargeableWeight } from "@/lib/shipment-functions";
import { AddPackageBox } from "@/components/svg";
import classNames from "classnames";

export default function PackageDetails({
  formData,
  setFormData,
  userBoxes,
  isError,
  setIsError,
  setIsLoading,
}) {
  const [itemValueUpdateCounter, setItemValueUpdateCounter] = useState(0);
  const [scrollFlag, setScrollFlag] = useState(false);
  const [shippingRateUpdateEvent, setShippingRateUpdateEvent] = useState(0);

  useNoInitialRenderEffect(() => {
    const element = document.querySelector(
      `#package-${formData.packages.length - 1}`
    );
    element.scrollIntoView({ block: "start", behavior: "smooth" });
    setScrollFlag(false);
  }, [scrollFlag]);

  const updatePackage = (action, input, packageIndex, itemIndex) => {
    const dataHolder = { ...formData };
    switch (action) {
      case "addPackage":
        dataHolder.packages.push({
          key: uuidv4(),
          length: "",
          width: "",
          height: "",
          weight: "",
          regularPackingCost: 0,
          fragilePackingCost: 0,
          validPackingType: true,
          validLength: "none",
          validWidth: "none",
          validHeight: "none",
          validWeight: "none",
          packingType: "No",
          items: [
            {
              key: uuidv4(),
              isFragile: false,
              quantity: "",
              description: "",
              totalValue: "",
              totalWeight: "",
              validQuantity: "none",
              validDescription: "none",
              validCategory: "none",
              validTotalValue: "none",
              validTotalWeight: "none",
            },
          ],
        });
        setScrollFlag(true);
        break;
      case "removePackage":
        if (formData.packages.length > 1) {
          dataHolder.packages.splice(packageIndex, 1);
        }
        setShippingRateUpdateEvent(shippingRateUpdateEvent + 1);
        setIsLoading(true);
        break;
      case "addItem":
        dataHolder.packages[packageIndex].items.push({
          key: uuidv4(),
          quantity: "",
          description: "",
          totalValue: "",
          totalWeight: "",
          validQuantity: "none",
          validDescription: "none",
          validCategory: "none",
          validTotalValue: "none",
          validTotalWeight: "none",
          isFragile:
            dataHolder.packages[packageIndex].packingType === "Fragile",
        });
        break;
      case "removeItem":
        if (dataHolder.packages[packageIndex].items.length > 1) {
          dataHolder.packages[packageIndex].items.splice(itemIndex, 1);
        }
        setItemValueUpdateCounter(
          (itemValueUpdateCounter) => itemValueUpdateCounter + 1
        );
        break;
      case "item":
        dataHolder.packages[packageIndex].items[itemIndex] = {
          ...dataHolder.packages[packageIndex].items[itemIndex],
          ...input,
        };

        break;
      case "package":
        dataHolder.packages[packageIndex] = {
          ...dataHolder.packages[packageIndex],
          ...input,
        };
        setShippingRateUpdateEvent(shippingRateUpdateEvent + 1);
        setIsLoading(true);
        break;
      default:
        dataHolder.packages[packageIndex][action] = input;
    }
    setFormData((formData) => dataHolder);
  };

  useDebouncedEffect(
    () => {
      const executeGetShippingCost = async () => {
        try {
          const shipmentChargeableWeight = formData.packages.reduce(
            (acc, curr) => {
              return acc + getParcelChargeableWeight(curr);
            },
            0
          );
          const quote = await getShippingCost(
            shipmentChargeableWeight,
            formData.recipientCountry
          );
          if (typeof quote === "number") {
            setFormData((formData) => {
              return { ...formData, initialFreightQuote: quote };
            });
          }
        } catch (err) {
          console.error(err);
        } finally {
          setIsLoading(false);
        }
      };
      executeGetShippingCost();
    },
    [shippingRateUpdateEvent],
    500
  );

  console.log(formData);
  return (
    <div className="w-full ">
      {formData.packages.map((parcel, index) => (
        <Package
          key={parcel.key}
          parcel={parcel}
          updatePackage={updatePackage}
          itemsList={parcel.items}
          packageIndex={index}
          formData={formData}
          itemValueUpdateCounter={itemValueUpdateCounter}
          setItemValueUpdateCounter={setItemValueUpdateCounter}
          userBoxes={userBoxes}
          isError={isError}
          setIsError={setIsError}
        />
      ))}
      <div className="mx-4 md:mx-0">
        <AddButton
          onClick={() => updatePackage("addPackage")}
          className="rounded-lg h-16 md:h-24 border-none relative overflow-hidden shadow"
        >
          Add Another Package
          <AddPackageBox
            className={classNames(
              "absolute h-14 w-14 sm:h-16 sm:w-16 md:h-24 md:w-24",
              "-bottom-1 right-2 sm:right-2.5 opacity-40 md:opacity-70 text-light-purple"
            )}
          />
        </AddButton>
      </div>
    </div>
  );
}
